import { Navigate } from "react-router-dom";
import { useSSO } from "../context/AuthContext";

const PrivateRoute = ({ Component }) => {
  const { accessToken } = useSSO();

  return accessToken ? <Component /> : <Navigate to="/logout" />;
};

export default PrivateRoute;